/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Year_Bind_InvalidInputs */

const en_ledger_error_year_bind_invalid = /** @type {(inputs: Ledger_Error_Year_Bind_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query does not bind the booking year correctly`)
};

const nl_ledger_error_year_bind_invalid = /** @type {(inputs: Ledger_Error_Year_Bind_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De query bindt het boekjaar niet correct`)
};

/**
* | output |
* | --- |
* | "The query does not bind the booking year correctly" |
*
* @param {Ledger_Error_Year_Bind_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_year_bind_invalid = /** @type {((inputs?: Ledger_Error_Year_Bind_InvalidInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Year_Bind_InvalidInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_year_bind_invalid(inputs)
	return en_ledger_error_year_bind_invalid(inputs)
});